import { authFetch } from '../../../auth'
import { useRef } from 'react'
import { replaceAccentedCharacters } from '../../../helpers/utils'
import dayjs from '../../../utils/dayjsConfig'

export const useFetchProducts = (baseBackendUrl) => {
  const abortProductController = useRef(null)

  const fetchProducts = async (inputValue = '', pageNumber = 1) => {
    if (inputValue.length < 3) return { options: [], hasMore: false }

    if (pageNumber === 1 && abortProductController.current) {
      abortProductController.current.abort()
    }
    abortProductController.current = new AbortController()

    try {
      const url = `${baseBackendUrl}/products?q=${replaceAccentedCharacters(
        inputValue
      )}&productactive=true&page=${pageNumber}&per_page=25`

      const response = await authFetch(url, {
        method: 'GET',
        signal: abortProductController.current.signal,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) throw new Error('Network error')

      const data = await response.json()
      const options = (data.table || []).map((p) => ({
        value: p.id,
        label: `${p.db_ref} - ${p.name}`,
        product: p,
        created_at: p.created_at || dayjs().toISOString()

      }))

      const hasMore = pageNumber * 25 < (data.count || 0)
      return { options, hasMore }
    } catch (error) {
      if (error.name !== 'AbortError')
        console.error('Error fetching products:', error)
      return { options: [], hasMore: false }
    }
  }

  return { fetchProducts }
}
